import React from 'react';
import { Box } from '@tanium/react-box';
import { LayoutStyleProps } from '@tanium/style-system';
import { BORDER_WIDTH } from '../../constants';
import { ContainerBorder, ContainerShadow } from '../../themeDefinitions';

interface StackedRibbonListWrapperProps extends Pick<LayoutStyleProps, 'height' | 'width'> {
  /**
   * Indicates that AdvancedFilters are being included in the wrapper.
   * It's used to alter the wrapper's style to account for AdvancedFilters.
   */
  hasAdvancedFilter?: boolean;
  children?: React.ReactNode;
}

/**
 * A wrapper component to be used around a StackedRibbonList component, providing a container with
 * appropriate border.
 */
export const StackedRibbonListWrapper = ({
  children,
  height,
  width,
  hasAdvancedFilter,
}: StackedRibbonListWrapperProps) => (
  <Box
    border={1}
    borderWidth={`${BORDER_WIDTH}px`}
    borderColor={ContainerBorder}
    borderBottomRadius={1}
    borderTopRadius={hasAdvancedFilter ? 0 : 1}
    overflow="hidden"
    height={height}
    width={width}
    boxShadow={ContainerShadow}
  >
    {children}
  </Box>
);
